module.exports = __webpack_public_path__ + "static/img/008.a5122fbd.png";